import React from 'react';
import './index.less';

export function KidsModeDisclaimer() {
	return <span className="kids-discaimer-text">Purchases not available in Kids</span>;
}
